<div class="status-tracker" role="region" aria-label="steps" *ngIf="visibleSections$ | async as visibleSections">
  <mat-stepper labelPosition="bottom" #stepper>
    <mat-step
      editable="false"
      [state]="section.shortDescription"
      *ngFor="let section of visibleSections;"
      >
      <ng-template matStepLabel *ngIf="!(isMobile$ | async)">
        <span
          [ngClass]="{
            'not-started':
              section.status === SectionStates.notStarted &&
              section.description !== selectedSection,
            'current-section': section.description === selectedSection
          }"
          >{{ section.description }}</span
        >
      </ng-template>
      <ng-template [matStepperIcon]="section.shortDescription">
        <mat-icon
          *ngIf="section.status === SectionStates.notStarted"
          class="notStarted"
          [ngClass]="{
            'currentSection': section.description === selectedSection
          }"
          [attr.aria-hidden]="null"
          [attr.alt]="'Step '+(section.section+1)"
        ></mat-icon>
        <mat-icon
          class="completedCheckmark icon-centered"
          *ngIf="section.status === SectionStates.complete"
          svgIcon="check_circle"
          [attr.aria-hidden]="null"
          [attr.alt]="'Step '+(section.section+1)"
        ></mat-icon>
      </ng-template>
    </mat-step>
  </mat-stepper>
</div>
